import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import {
  RentVisitFeedbackBody,
  createVisitFeedbackEndpoint,
  updateVisitStateEndpoint,
} from '../services/dashboardService';
import {
  deleteVisitEndpoint,
  getCancellationReasons,
} from '../../properties/services/propertyService';
import { useState } from 'react';

// Acciones del Proper sobre una visita de Renta/Secondary: las mismas que ya
// usa su dashboard (marcar como realizada y cancelar).
const useProperRentVisitActions = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const [cancellationReasons, setCancellationReasons] = useState<string[]>([]);

  const doMarkAsDone = async (visitId: string): Promise<number> => {
    const { status } = await callEndpoint(
      updateVisitStateEndpoint(visitId, true, token),
    );
    return status;
  };

  // Feedback (Renta/Venta) antes de cerrar la visita. 409 = ya registrado.
  const doSendFeedback = async (
    visitId: string,
    body: RentVisitFeedbackBody,
  ): Promise<{ ok: boolean; message?: string }> => {
    const { status, data } = await callEndpoint(
      createVisitFeedbackEndpoint(visitId, token, body),
    );
    if (status === 201 || status === 200 || status === 409) return { ok: true };
    if (status === 404)
      return {
        ok: false,
        message: 'La visita no existe o no está asignada a este Proper.',
      };
    const detail = data?.data?.detail;
    return {
      ok: false,
      message:
        (typeof detail === 'string' && detail) ||
        data?.message ||
        'No se pudo guardar el feedback. Intenta de nuevo.',
    };
  };

  const doCancelVisit = async (
    visitId: string,
    reason: string,
    explainReason: string,
  ): Promise<number> => {
    const { status } = await callEndpoint(
      deleteVisitEndpoint(visitId, token, reason, explainReason),
    );
    return status;
  };

  const doLoadCancellationReasons = async () => {
    try {
      const { data } = await callEndpoint(getCancellationReasons(token));
      setCancellationReasons(Array.isArray(data.data) ? data.data : []);
    } catch {
      setCancellationReasons([]);
    }
  };

  return {
    cancellationReasons,
    doMarkAsDone,
    doSendFeedback,
    doCancelVisit,
    doLoadCancellationReasons,
  };
};

export default useProperRentVisitActions;
